
<style scoped>
.upload_form{
	display: block;
	height: 90px;
	width:100%;
	background: #FFFF;
	padding-top:18px;
	text-align: center;
	border: 2px solid rgba(109, 124, 142, 0.5);
	box-sizing: border-box;
	box-shadow: 0px 5px 10px rgba(162, 158, 158, 0.2);
	border-radius: 10px;
}

div.file-listing{
	margin: auto;
	padding: 10px;
}

div.remove-container a{
	color: red;
	cursor: pointer;
}
.pre-image{
	height: 142px;
	/*width: 142px;*/
	border-radius: 10px;
}

</style>
<template>
	<div id="file-drag-drop">
		<div v-if="!file">
			
			<label class="cursor-pointer ">
				<input  type="file" ref="files" 
				@change="browseFile($event)"
				:accept="$keys.ACCEPTED_IMAGE_FORMATE"  hidden >
				<form ref="fileform"  class="upload_form text-center">
					<img src="@/assets/upload-2.svg" alt="" width="30px">
					<br>
					<p class="secodry-text-2 fs-13">{{file_input_label}}</p>
				</form>
			</label>
		</div>

		<div class="pt-3"  v-else>
			
			<img :src="preview_url" alt="img" class="pre-image ">

			<v-btn fab width="16px" height="16px" color="#FFF"
			@click="removeFile()"
			class="v-align-top"
			style="margin-left: -10px;margin-top: -5px"
			>
			<v-icon size="10" color="error"> mdi-window-close</v-icon>
		</v-btn>
	</div>
<!-- 	<div class="file-listing text-center" v-if="file"  >
		{{file.name}}
		<div class="remove-container">
			<a class="remove" @click="removeFile()">Remove</a>
		</div>
	</div> -->
</div>
</template>
<script>
export default{
	props:['file_input_label'],
	data(){
		return {
			dragAndDropCapable: false,
			btn_loading:false,
			file:null,
			preview_url:"",
		}
	},

	mounted(){
		const self=this
		this.dragAndDropCapable = this.determineDragAndDropCapable();
		if( this.dragAndDropCapable ){

			['drag', 'dragstart', 'dragend', 'dragover', 'dragenter', 'dragleave', 'drop'].forEach( function( evt ) {

				this.$refs.fileform.addEventListener(evt, function(e){
					e.preventDefault();
					e.stopPropagation();
				}.bind(this), false);
			}.bind(this));


			this.$refs.fileform.addEventListener('drop', function(e){

				/* Apply validations */ 
				if (e.dataTransfer.files.length>1){
					this.$store.dispatch('snackbar/setSnackbar', {flag:true, text:this.$messages.MULTIPLE_FILE_NOT_SUPPORTED, color:this.$keys.WARNING })
					return false
				}
				if(!this.$keys.ACCEPTED_IMAGE_FORMATE.includes(e.dataTransfer.files[0]['type'])){
					self.$store.dispatch('snackbar/setSnackbar', {flag:true, text:self.$messages.INVALID_FILE, color:'error' })
					return false;
				}
				if(e.dataTransfer.files[0].size>(1024*1024*this.$keys.MAX_FILE_SIZE)){
					self.$store.dispatch('snackbar/setSnackbar', {flag:true, text:self.$messages.MAX_FILE_SIZE_ERROR+ this.$keys.MAX_FILE_SIZE, color: this.$keys.ERROR })
					return false;
				}

				// this.file.image=e.dataTransfer.files[0]
				this.updateImage(e.dataTransfer.files[0])


			}.bind(this));
		}
	},
	methods: {
		determineDragAndDropCapable(){
			var div = document.createElement('div');

			return ( ( 'draggable' in div )
				|| ( 'ondragstart' in div && 'ondrop' in div ) )
			&& 'FormData' in window
			&& 'FileReader' in window;
		},

		/* upload Csv*/
		browseFile(e){
			const self= this		
			self.csv_loading=true;

			if(!this.$keys.ACCEPTED_IMAGE_FORMATE.includes(e.target.files[0]['type'])){
				self.$store.dispatch('snackbar/setSnackbar', {flag:true, text:self.$messages.INVALID_FILE, color:'error' })
				return false;
			}
			if(e.target.files[0].size>(1024*1024*this.$keys.MAX_FILE_SIZE)){
				self.$store.dispatch('snackbar/setSnackbar', {flag:true, text:self.$messages.MAX_FILE_SIZE_ERROR+ this.$keys.MAX_FILE_SIZE, color: this.$keys.ERROR })
				return false;
			}
			// this.file.retailer_file=e.target.files[0]
			this.updateImage(e.target.files[0]);
			this.preview_url=URL.createObjectURL(e.target.files[0])


		},

		removeFile(){
			this.updateImage(null);
		},
		updateImage(file){
			this.file=file
			console.log(file)
			this.$emit("update-image",file)
		}

	}
}

</script>